import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getIndustryTypesApi,
  postAddIndustryTypeApi,
  postGenerateQrCodeApi,
  putUpdateIndustryTypeApi,
} from "../api/generic";
import { PostAddIndustryTypeProps } from "../types/types";

export const useGetIndustryTypes = () => {
  return useQuery({
    queryKey: ["getIndustryTypes"],
    queryFn: () => getIndustryTypesApi(),
  });
};

export const usePostAddIndustryType = () => {
  return useMutation({
    mutationKey: ["postAddIndustryType"],
    mutationFn: (data: PostAddIndustryTypeProps) =>
      postAddIndustryTypeApi(data),
  });
};

export const usePutUpdateIndustryType = () => {
  return useMutation({
    mutationKey: ["putUpdateIndustryType"],
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: PostAddIndustryTypeProps;
    }) => putUpdateIndustryTypeApi({ id, data }),
  });
};

export const usePostGenerateQrCode = () => {
  return useMutation({
    mutationKey: ["postGenerateQrCode"],
    mutationFn: (data: { url: string }) => postGenerateQrCodeApi(data),
  });
};
